import React from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type businessBillingDetailsForm_Billing_CustomerDetailsFragment$key } from "@relay/businessBillingDetailsForm_Billing_CustomerDetailsFragment.graphql";
import { BUSINESS_BILLING_DETAILS_FRAGMENT } from "./business-billing-details-form.graphql";
import { type BusinessBillingDetailsFormProps } from "./business-billing-details-form.interface";
import { TextDisplayField } from "../../../../components/text-display-field/text-display-field.component";
import { CompanyType } from "../../../../translations/CompanyType";

export const BusinessBillingDetailsForm = ({
	businessBillingDetailsFragmentRef,
}: BusinessBillingDetailsFormProps) => {
	const { t } = useTranslation("common");
	const businessBillingDetails =
		useFragment<businessBillingDetailsForm_Billing_CustomerDetailsFragment$key>(
			BUSINESS_BILLING_DETAILS_FRAGMENT,
			businessBillingDetailsFragmentRef,
		);
	return (
		<div className="p-4">
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.firstName")}
					value={businessBillingDetails.firstName}
				/>
				<TextDisplayField
					label={t("billing.lastName")}
					value={businessBillingDetails.lastName}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.street")}
					value={businessBillingDetails.street}
				/>
				<TextDisplayField
					label={t("billing.houseNumber")}
					value={businessBillingDetails.houseNumber}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField label={t("billing.city")} value={businessBillingDetails.city} />
				<TextDisplayField
					label={t("billing.postalCode")}
					value={businessBillingDetails.postalCode}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.country")}
					value={businessBillingDetails.country}
				/>
				<TextDisplayField
					label={t("billing.salutation")}
					value={businessBillingDetails.salutation}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.invoiceEmail")}
					value={businessBillingDetails.invoiceEmail}
				/>
				<TextDisplayField
					label={t("billing.legalForm")}
					value={
						businessBillingDetails.data.companyType
							? CompanyType[businessBillingDetails.data.companyType]
							: undefined
					}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.companyName")}
					value={businessBillingDetails.data.company}
				/>
				<TextDisplayField
					label={t("billing.companyDetails")}
					value={businessBillingDetails.data.companyDetails ?? undefined}
				/>
			</div>
		</div>
	);
};
